import React, { FC } from 'react';
import { useFormik } from 'formik';
import Yup from '~yup';

import { TCreateNewRegionReduxParams } from '~types/feat/branch';

import LabelledInput from '~components/atoms/LabelledInput';
import ActionButton from '~components/atoms/ActionButton';
import Text from '~components/atoms/Text';

import UtilFunctions from '~utils/functions';

import * as FormStyles from './_regionBaseForm.module.scss';

const RegionBaseFormValidation = Yup.object().shape({
    regionName: Yup.string().matchNoLeadingAndTrailingWhiteSpaces().matchMaxOneWhiteSpace().matchNumbersAndUppercaseAlphabetsOnly().required('Region Name is required'),
});

type TRegionBaseForm = {
    submitButtonLabel: string;
    onSubmit: (data: TCreateNewRegionReduxParams) => void;
    error: string;
    inputIsDisabled?: boolean;
    actionButtonIsLoading?: boolean;
    actionButtonClassName?: string;
}

const RegionBaseForm: FC<TRegionBaseForm> = ({
    submitButtonLabel,
    onSubmit,
    error,
    inputIsDisabled,
    actionButtonIsLoading,
    actionButtonClassName,
}) => {
    const { Misc: { blockEnterKey } } = UtilFunctions;

    const RegionBaseFormInitialValues: TCreateNewRegionReduxParams = {
        regionName: '',
    };

    const formik = useFormik({
        initialValues: RegionBaseFormInitialValues,
        validationSchema: RegionBaseFormValidation,
        onSubmit: (values) => onSubmit(values),
    });

    return (
        <form
            onSubmit={formik.handleSubmit}
            className={FormStyles.container}
            onKeyDown={blockEnterKey}
        >
            <div className={FormStyles['form-container']}>
                <LabelledInput
                    id='regionName'
                    name='regionName'
                    label='Region Name* :'
                    value={formik.values.regionName}
                    error={formik.touched.regionName ? formik.errors.regionName : undefined}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />

                <div className={`${FormStyles['button-container']} ${FormStyles['span-2']}`}>
                    <div className={FormStyles['button-subcontainer']}>
                        <ActionButton
                            label={submitButtonLabel}
                            isLoading={actionButtonIsLoading}
                            type='submit'
                            disabled={actionButtonIsLoading}
                            className={actionButtonClassName}
                        />

                        <Text
                            label={error}
                            isError
                        />
                    </div>
                </div>
            </div>
        </form>
    );
};

export default RegionBaseForm;
